// removed by extract-text-webpack-plugin
module.exports = {"root":"cms__AuthenticationPage__root","button":"cms__AuthenticationPage__button"};


//////////////////
// WEBPACK FOOTER
// ./backends/github/AuthenticationPage.css
// module id = 544
// module chunks = 0